import React from 'react';
import MultiLanguageContext from '.';

export default function useMultiLanguageContext() {
  const context = React.useContext(MultiLanguageContext);
  if (!context) {
    throw new Error('useMultiLanguageContext must be used within a MultiLanguageContextProvider');
  }
  return context;
}
